import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { ComboBox, InputWithLabel, RadioGroup, Text } from '@reveni-io/reveni-ui'

import AffectedProductsEditor from '@/configuration/pages/ConfigurationPage/ReturnPolicy/PolicyRulesConfiguration/PolicyRuleDetailConfiguration/PolicyRuleActionEditor/AffectedProductsEditor/AffectedProductsEditor'
import CustomMessage from '@/configuration/pages/ConfigurationPage/ReturnPolicy/PolicyRulesConfiguration/PolicyRuleDetailConfiguration/PolicyRuleActionEditor/CustomMessage/CustomMessage'

import { customMessageTypeOptions, feeApplicationModeValues } from './constants'
import * as Styles from './styles'

const ApplyExtraFeeConfig = ({
  config,
  onChangeConfig,
  disabled,
  currencyOptions,
  currencies,
  storeCurrencyCode,
  productTypes,
  productCategories,
  productCollections,
  errors = [],
}) => {
  const theme = useTheme()
  const { t } = useTranslation()

  const hasFeeNameError = errors.some(e => e.type === 'actionFeeNameEmpty')
  const hasFeeAmountError = errors.some(e => e.type === 'actionFeeAmountEmpty')
  const hasFeeCurrencyError = errors.some(e => e.type === 'actionFeeCurrencyEmpty')

  const radioOptions = [
    { label: t('Aplicar una vez por solicitud'), value: feeApplicationModeValues.perRequest },
    {
      label: t('Aplicar una vez por cada producto coincidente a devolver'),
      value: feeApplicationModeValues.perMatchingProduct,
    },
  ]

  return (
    <Styles.Container>
      <Text type="bodyMBold">{t('Configuración de las tasas')}</Text>
      <InputWithLabel
        label={t('Nombre de tasa')}
        value={config.fee_concept || ''}
        onChange={e => onChangeConfig({ fee_concept: e.target.value })}
        maxLength={50}
        showCounter
        fullWidth
        disabled={disabled}
        backgroundColor={theme.colors.background.primary}
        error={hasFeeNameError}
        helperText={hasFeeNameError ? t('Este campo es obligatorio') : undefined}
      />
      <Styles.AmountRow>
        <InputWithLabel
          label={t('Importe')}
          value={config.fee_amount || ''}
          onChange={e => onChangeConfig({ fee_amount: e.target.value })}
          type="number"
          fullWidth
          disabled={disabled}
          backgroundColor={theme.colors.background.primary}
          error={hasFeeAmountError}
          helperText={hasFeeAmountError ? t('Este campo es obligatorio') : undefined}
        />
        <ComboBox
          label={t('Divisa')}
          menuItems={currencyOptions || []}
          handleChange={e => onChangeConfig({ fee_currency: e.target.value })}
          value={config.fee_currency || ''}
          fullWidth
          disabled={disabled}
          backgroundColor={theme.colors.background.primary}
          error={hasFeeCurrencyError}
          helperText={hasFeeCurrencyError ? t('Este campo es obligatorio') : ' '}
        />
      </Styles.AmountRow>
      <RadioGroup
        name="fee-application-mode"
        options={radioOptions}
        value={config.fee_application_mode || feeApplicationModeValues.perRequest}
        onChange={e => onChangeConfig({ fee_application_mode: e.target.value })}
      />
      {config.fee_application_mode === feeApplicationModeValues.perMatchingProduct && (
        <AffectedProductsEditor
          config={config}
          onChangeConfig={onChangeConfig}
          disabled={disabled}
          currencies={currencies}
          storeCurrencyCode={storeCurrencyCode}
          productTypes={productTypes}
          productCategories={productCategories}
          productCollections={productCollections}
        />
      )}
      <CustomMessage
        enabled={config.custom_message_enabled}
        message={config.custom_message}
        customMessageType={config.custom_message_type}
        customMessageTypeOptions={customMessageTypeOptions}
        onChangeConfig={onChangeConfig}
        disabled={disabled}
        errors={errors}
      />
    </Styles.Container>
  )
}

export default ApplyExtraFeeConfig
